import React from "react";
import {
    Wrapper,
    AccessIcon,
    Heading,
    SubText,
} from './styled';

const Layout = () => {
    return <Wrapper>
        <AccessIcon/>
        <Heading>The public request portal is currently disabled</Heading>
        <SubText>Please contact your administrator for more information.</SubText>
    </Wrapper>
}

export default Layout;